import React, { useContext } from 'react';

import usePopup from 'hooks/usePopup';
import useTextCardContent from 'hooks/useTextCardContent';
import CanvasContext from 'contexts/CanvasContext';

import EditTextCardForm from '../TextCardForm/EditTextCardForm';
import StudioTextBody from './StudioTextBody';
import TextGadget from './TextGadget';

const TextGadgetContainer = ({ textContentId }: { textContentId: string }) => {
  const { isEditing: isEditingCanvas } = useContext(CanvasContext);
  const { text, isCenterAlign, studio, format, background } =
    useTextCardContent(textContentId);
  const isMarkdown = format === 'markdown';
  const hasMetrics = !!studio && (studio.metricIds ?? []).length > 0;
  const {
    isOpen: isEditFormOpen,
    open: openEditForm,
    close: closeEditForm,
  } = usePopup(false);

  return (
    <>
      <TextGadget
        text={text}
        isCenterAlign={!!isCenterAlign}
        isBottomAlign={!!studio && !!studio.isTextAtBottom}
        // Markdown is edited in Studio: the classic form's rich text editor
        // would turn it into rich text
        onEdit={isMarkdown ? undefined : openEditForm}
        isEditingCanvas={isEditingCanvas}
        background={background}
        body={
          hasMetrics || isMarkdown ? (
            <StudioTextBody
              id={textContentId}
              text={text}
              format={format}
              verticalAlign={
                isCenterAlign
                  ? 'middle'
                  : studio && studio.isTextAtBottom
                    ? 'bottom'
                    : 'top'
              }
              studio={studio}
            />
          ) : undefined
        }
      />
      <EditTextCardForm
        isOpen={isEditFormOpen}
        close={closeEditForm}
        textContentId={textContentId}
      />
    </>
  );
};

export default TextGadgetContainer;
